import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlights = () => {
  const features = [
    {
      icon: 'TrendingUp',
      title: 'Advanced Analytics',
      description: 'PTS-WIZARD-V3 algorithm with 40+ configurable parameters for precise market analysis'
    },
    {
      icon: 'Shield',
      title: 'Bank-Grade Security',
      description: 'Multi-layer encryption, 2FA, and cold storage protection for your assets'
    },
    {
      icon: 'BarChart3',
      title: 'Real-Time Data',
      description: 'Live market feeds from 15+ exchanges with millisecond precision'
    },
    {
      icon: 'Zap',
      title: 'Lightning Fast',
      description: 'Execute trades in under 100ms with our optimized trading engine'
    },
    {
      icon: 'PieChart',
      title: 'Portfolio Tracking',
      description: 'Comprehensive P&L analysis with automated tax reporting'
    },
    {
      icon: 'Bell',
      title: 'Smart Alerts',
      description: 'AI-powered notifications for price movements and trading opportunities'
    }
  ];

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-foreground mb-3">
          Why Choose CryptoWizard Pro?
        </h2>
        <p className="text-muted-foreground">
          Join thousands of traders who trust our platform for professional-grade crypto trading
        </p>
      </div>
      <div className="grid gap-6">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-4">
            <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={feature?.icon} size={24} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-medium text-foreground mb-1">
                {feature?.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Trust Indicators */}
      <div className="pt-6 border-t border-border">
        <div className="text-center mb-4">
          <h3 className="text-lg font-medium text-foreground mb-2">Trusted & Secure</h3>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="flex items-center justify-center space-x-2 p-3 bg-muted/50 rounded-lg">
            <Icon name="Shield" size={16} color="var(--color-success)" />
            <span className="text-sm font-medium text-foreground">SSL Secured</span>
          </div>
          <div className="flex items-center justify-center space-x-2 p-3 bg-muted/50 rounded-lg">
            <Icon name="Lock" size={16} color="var(--color-success)" />
            <span className="text-sm font-medium text-foreground">SOC 2 Compliant</span>
          </div>
          <div className="flex items-center justify-center space-x-2 p-3 bg-muted/50 rounded-lg">
            <Icon name="Users" size={16} color="var(--color-accent)" />
            <span className="text-sm font-medium text-foreground">50K+ Users</span>
          </div>
          <div className="flex items-center justify-center space-x-2 p-3 bg-muted/50 rounded-lg">
            <Icon name="Star" size={16} color="var(--color-warning)" />
            <span className="text-sm font-medium text-foreground">4.9/5 Rating</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureHighlights;